export default {
  empty: {
    EN: "No proposals found.",
  },
  "create-success": {
    EN: "Successfully created Proposal",
  },
  "create-failure": {
    EN: "Failed to create Proposal",
  },
  "delete-success": {
    EN: "Successfully deleted Proposal",
  },
  "delete-failure": {
    EN: "Failed to delete Proposal",
  },
  "update-success": {
    EN: "Successfully updated the Proposal",
  },
  "update-failure": {
    EN: "Failed to update the proposal. Please try again.",
  },
  "add-stage-success": {
    EN: "Successfully added stage",
  },
  "add-stage-failure": {
    EN: "Failed to add stage",
  },
  "add-products-to-proposal-stage-success": {
    EN: "Successfully added product(s) to proposal stage.",
  },
  "add-products-to-proposal-stage-failure": {
    EN: "Failed to add product(s) to proposal stage",
  },
  "add-stage-address-success": {
    EN: "Successfully added address to the proposal stage",
  },
  "add-stage-address-failure": {
    EN: "Failed to add address to the proposal stage",
  },
  "update-proposal-plant-product-success": {
    EN: "Successfully updated the proposal plant product",
  },
  "update-proposal-plant-product-failure": {
    EN: "Failed to update the proposal plant product",
  },
  "update-proposal-product-success": {
    EN: "Successfully updated the proposal product",
  },
  "update-proposal-product-failure": {
    EN: "Failed to update the proposal product",
  },
  "add-proposal-equipment-piece-success": {
    EN: "Successfully added equipment piece to proposal product",
  },
  "add-proposal-equipment-piece-failure": {
    EN: "Failed to add equipment piece to proposal product",
  },
  "add-proposal-equipment-pieces-success": {
    EN: "Successfully added equipment piece(s) to proposal product",
  },
  "add-proposal-equipment-pieces-failure": {
    EN: "Failed to add equipment piece(s) to proposal product",
  },
  "add-proposal-crew-success": {
    EN: "Successfully added crew to proposal product",
  },
  "add-proposal-crew-failure": {
    EN: "Failed to add crew to proposal product",
  },
  "add-proposal-crews-success": {
    EN: "Successfully added crew(s) to proposal product",
  },
  "add-proposal-crews-failure": {
    EN: "Failed to add crew(s) to proposal product",
  },
  "add-proposal-additional-cost-success": {
    EN: "Successfully added additional cost to proposal product",
  },
  "add-proposal-additional-cost-failure": {
    EN: "Failed to add additional cost to proposal product",
  },
  "add-proposal-additional-costs-success": {
    EN: "Successfully added additional cost to proposal product",
  },
  "add-proposal-additional-costs-failure": {
    EN: "Failed to add additional cost to proposal product",
  },
  "add-proposal-file-success": {
    EN: "Successfully added file to the proposal product",
  },
  "add-proposal-file-failure": {
    EN: "Failed to add the file to the proposal product",
  },
  "delete-proposal-file-success": {
    EN: "Successfully deleted the proposal file",
  },
  "delete-proposal-file-failure": {
    EN: "Failed to delete the proposal file",
  },
  "send-success": {
    EN: "Successfully sent the proposal",
  },
  "package-send-queued": {
    EN: "Proposal send queued. View progress on the proposal.",
  },
  "send-failure": {
    EN: "Failed to send the proposal",
  },
  "set-to-draft-success": {
    EN: "Successfully set proposal to Draft",
  },
  "set-to-draft-failure": {
    EN: "Failed to set proposal to Draft",
  },
  "close-proposal-success": {
    EN: "Successfully closed the Proposal",
  },
  "close-proposal-failure": {
    EN: "Failed to close the Proposal",
  },
  "update-proposal-info-success": {
    EN: "Successfully updated the Proposal info",
  },
  "update-proposal-info-failure": {
    EN: "Failed to update the Proposal info",
  },
  "send-proposal-to-recipient-success": {
    EN: "Successfully sent the Proposal to Recipient",
  },
  "send-proposal-to-recipient-failure": {
    EN: "Failed to send the Proposal to Recipient",
  },
  "delete-proposal-recipient-success": {
    EN: "Successfully deleted the Proposal Recipient",
  },
  "delete-proposal-recipient-failure": {
    EN: "Failed to delete the Proposal Recipient",
  },
  "cancel-proposal-success": {
    EN: "Successfully cancelled the Proposal",
  },
  "cancel-proposal-failure": {
    EN: "Failed to cancel the Proposal",
  },
  "duplicate-proposal-success": {
    EN: "Successfully duplicated the Proposal",
  },
  "duplicate-proposal-failure": {
    EN: "Failed to duplicate the Proposal",
  },
  "delete-proposal-product-success": {
    EN: "Successfully deleted the proposal product",
  },
  "delete-proposal-product-failure": {
    EN: "Failed to delete the proposal product",
  },
  "delete-proposal-stage-success": {
    EN: "Successfully deleted the proposal stage",
  },
  "delete-proposal-stage-failure": {
    EN: "Failed to delete the proposal stage",
  },
  "duplicate-proposal-stage-success": {
    EN: "Job duplicated",
  },
  "duplicate-proposal-stage-failure": {
    EN: "Failed to duplicate job",
  },
  "copy-proposal-product-to-stage-success": {
    EN: "Product copied",
  },
  "copy-proposal-product-to-stage-failure": {
    EN: "Failed to copy product",
  },
  "update-stage-address-success": {
    EN: "Successfully updated the stage address",
  },
  "update-stage-address-failure": {
    EN: "Failed to update the stage address",
  },
  "delete-map-image-success": {
    EN: "Map Image deleted successfully",
  },
  "delete-map-image-failure": {
    EN: "Failed to delete Map Image",
  },
  "add-truck-to-proposal-product-success": {
    EN: "Truck added to proposal product successfully!",
  },
  "add-truck-to-proposal-product-failure": {
    EN: "Failed to add truck to proposal product.",
  },
  "remove-truck-from-proposal-product-success": {
    EN: "Truck removed from proposal product successfully!",
  },
  "remove-truck-from-proposal-product-failure": {
    EN: "Failed to remove truck from proposal product",
  },
  "preview-proposal-success": {
    EN: "Generated proposal preview successfully",
  },
  "preview-proposal-failure": {
    EN: "Failed to generate proposal preview",
  },
  "update-proposal-sales-taxes-success": {
    EN: "Saved",
  },
  "update-proposal-sales-taxes-failure": {
    EN: "Operation failed",
  },
  "update-proposal-content-setting-success": {
    EN: "Proposal section updated",
  },
  "update-proposal-content-setting-failure": {
    EN: "Failed to update proposal section",
  },
  "update-proposal-content-settings-success": {
    EN: "Proposal sections updated",
  },
  "update-proposal-content-settings-failure": {
    EN: "Failed to update proposal sections",
  },
  "update-proposal-discount-success": {
    EN: "Proposal discount updated",
  },
  "update-proposal-discount-failure": {
    EN: "Failed to apply discount",
  },
  "toggle-proposal-product-optionality-success": {
    EN: "Saved!",
  },
  "toggle-proposal-product-optionality-failure": {
    EN: "Operation failed",
  },
  "update-proposal-product-project-files-success": {
    EN: "Successfully added project file to the proposal product",
  },
  "update-proposal-product-project-files-failure": {
    EN: "Failed to add the project file to the proposal product",
  },
  "delete-proposal-product-project-file-success": {
    EN: "Successfully deleted the project file",
  },
  "delete-proposal-product-project-file-failure": {
    EN: "Failed to delete the project file",
  },
  "hold-proposal-success": {
    EN: "Successfully moved proposal to On Hold",
  },
  "hold-proposal-failure": {
    EN: "Failed to move proposal to On Hold",
  },
  "add-stage-checklist-items-success": {
    EN: "Stage requirements updated successfully",
  },
  "add-stage-checklist-items-failure": {
    EN: "Failed to update stage requirements",
  },
  "add-plant-product-to-proposal-product-success": {
    EN: "Successfully added material to proposal product",
  },
  "add-plant-product-to-proposal-product-failure": {
    EN: "Failed to add material to proposal product",
  },
  "delete-proposal-plant-product-success": {
    EN: "Successfully deleted material from proposal product",
  },
  "delete-proposal-plant-product-failure": {
    EN: "Failed to delete material from proposal product",
  },
  "delete-proposal-material-no-plant-success": {
    EN: "Successfully deleted material from proposal product",
  },
  "delete-proposal-material-no-plant-failure": {
    EN: "Failed to delete material from proposal product",
  },
  "add-material-no-plant-to-proposal-product-success": {
    EN: "Successfully added material to proposal product",
  },
  "add-material-no-plant-to-proposal-product-failure": {
    EN: "Failed to add material to proposal product",
  },
};
